import PropTypes from "prop-types";
import React, { Component } from "react";
import Overridable from "react-overridable";
import { List } from "semantic-ui-react";

const ET_AL_LABEL = "et al.";

class SpecialCollectionAuthors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }

  toggleShowAllAuthors = () => {
    const { isExpanded } = this.state;
    this.setState({ isExpanded: !isExpanded });
  };

  render() {
    const {
      authors,
      hasOtherAuthors,
      limit,
      prefix,
      delimiter,
      expandable,
      listItemAs,
    } = this.props;
    const { isExpanded } = this.state;

    const allAuthors = authors ? authors : [];
    let displayedAuthors = allAuthors;
    if (!isExpanded) {
      displayedAuthors = allAuthors.slice(0, limit);
    }

    const isShowingAllAuthors =
      allAuthors.slice(0, limit).length === allAuthors.length;
    const showAllAuthorsCmp =
      !isShowingAllAuthors && expandable ? (
        <div>
          {" "}
          <span
            className="button-show-more"
            onClick={this.toggleShowAllAuthors}
          >
            {isExpanded ? "Show less" : `Show all ${allAuthors.length} authors`}
          </span>
        </div>
      ) : null;

    return (
      <Overridable id="SpecialCollectionAuthors.layout" {...this.props}>
        <>
          <div className="default-margin-bottom">
            {prefix}
            <List horizontal className="document-authors-list" as={listItemAs}>
              {displayedAuthors.map((author, index) => {
                const isLast = index === displayedAuthors.length - 1;
                const authorName =
                  typeof author === "string"
                    ? author
                    : author.full_name || author.name;

                return (
                  <List.Item key={authorName || index}>
                    {authorName}
                    {!isLast ? delimiter : null}
                  </List.Item>
                );
              })}
              {hasOtherAuthors && (
                <List.Item key="others">{ET_AL_LABEL}</List.Item>
              )}
            </List>
          </div>
          {showAllAuthorsCmp}
        </>
      </Overridable>
    );
  }
}

SpecialCollectionAuthors.propTypes = {
  authors: PropTypes.array.isRequired,
  hasOtherAuthors: PropTypes.bool,
  limit: PropTypes.number,
  prefix: PropTypes.string,
  delimiter: PropTypes.string,
  expandable: PropTypes.bool,
  listItemAs: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
};

SpecialCollectionAuthors.defaultProps = {
  hasOtherAuthors: false,
  limit: 5,
  prefix: null,
  delimiter: ";",
  expandable: false,
  listItemAs: null,
};

export default Overridable.component(
  "SpecialCollectionAuthors",
  SpecialCollectionAuthors
);
